import { store } from "../app/store";
import { addErrorMessage } from "../core/errors/errorSlice";

export default (err: any) => {
	// Check if the request config has suppressErrorToast flag
	if (err.config && err.config.suppressErrorToast) {
		return Promise.reject(err);
	}

	if (err && err.response && err.response.data && err.response.data.message) {
		store.dispatch(
			addErrorMessage({
				title: "Error",
				body: err.response.data.message,
			})
		);
	} else if (err && err.message) {
		store.dispatch(
			addErrorMessage({
				title: "Error",
				body: err.message,
			})
		);
	} else {
		store.dispatch(
			addErrorMessage({
				title: "Error",
				body: "An unexpected error occurred",
			})
		);
	}
	return Promise.reject(err);
};
